import styled, { keyframes } from 'styled-components';
import { colors } from 'globalStyles';

const scaleout = keyframes`
  to {transform: rotate(360deg);}
`;

const StyledSpinner = styled.div`
  content: '';
  box-sizing: border-box;
  position: relative;
  top: 97%;
  left: 50%;
  width: 30px;
  height: 30px;
  margin-top: -15px;
  margin-left: -15px;
  border-radius: 50%;
  border: 1px solid #ccc;
  border-top-color: #07d;
  clear: both;
  animation: ${scaleout} .6s linear infinite;
`;

export default StyledSpinner;



// WEBPACK FOOTER //
// ./src/components/StyledSpinner/index.js